import styled from 'styled-components'

import PulsingGrey from '../PulsingGrey'
import Container from '../../layout/Container'
import { media } from '../../../styles/media'

/* the skeleton clips its placeholder rows to the page width */
export const BodyContainer = styled(Container)`
  overflow: hidden;
`

/* mirrors the adventure page's narrower content column */
export const NarrowerContainer = styled(Container)`
  max-width: 900px;
  overflow: hidden;
`

export const Wrapper = styled.div<{ $hasBottomBar?: boolean }>`
  /* fill the viewport so the page footer stays below the fold while loading */
  min-height: 100vh;

  /* leave room for the fixed mobile booking bar, when there is one */
  ${({ $hasBottomBar }) => $hasBottomBar && 'padding-bottom: 100px;'}

  ${media.lg`
    padding-bottom: 0;
  `}
`

export const SrOnly = styled.span`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
  white-space: nowrap;
  border: 0;
`

export const Block = styled(PulsingGrey)<{
  $w?: string
  $h?: string
  $r?: string
  $mt?: string
  $mb?: string
}>`
  width: ${({ $w }) => $w || '100%'};
  height: ${({ $h }) => $h || '14px'};
  border-radius: ${({ $r }) => $r || '4px'};
  ${({ $mt }) => $mt && `margin-top: ${$mt};`}
  ${({ $mb }) => $mb && `margin-bottom: ${$mb};`}
`

export const Hero = styled(PulsingGrey)`
  position: relative;
  width: 100%;
  height: 300px;

  /* desktop mirrors DesktopListingHeader's 16:9-ish aspect ratio */
  ${media.md`
    height: 0;
    padding-top: 37.777%;
  `}
`

const HeroButton = styled.div`
  position: absolute;
  background-color: rgba(255, 255, 255, 0.6);
`

export const HeartButton = styled(HeroButton)`
  top: 14px;
  right: 14px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
`

export const GalleryButton = styled(HeroButton)`
  bottom: 14px;
  right: 14px;
  width: 92px;
  height: 34px;
  border-radius: 18px;
`

export const Content = styled.div<{ $pt: string }>`
  padding-top: ${({ $pt }) => $pt};
`

/* the detail pages switch from single column to two columns at lg, not md */
export const Columns = styled.div`
  ${media.lg`
    display: flex;
    gap: 40px;
  `}
`

export const MainColumn = styled.div`
  ${media.lg`
    flex: 2;
  `}
`

export const SideColumn = styled.div`
  display: none;

  ${media.lg`
    display: block;
    flex: 1;
  `}
`

export const AuthorColumn = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;

  ${media.lg`
    flex: 1;
    flex-direction: column;
    align-items: flex-start;
  `}
`

export const AuthorRow = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
`

/* 54px inline on mobile, 160px in the desktop author column */
export const StoryAvatar = styled(PulsingGrey)`
  flex-shrink: 0;
  width: 54px;
  height: 54px;
  border-radius: 50%;

  ${media.lg`
    width: 160px;
    height: 160px;
  `}
`

export const Title = styled.div<{ $mt?: string; $mb?: string }>`
  ${({ $mt }) => $mt && `margin-top: ${$mt};`}
  ${({ $mb }) => $mb && `margin-bottom: ${$mb};`}
`

export const InlineRow = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`

export const AmenitiesGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px 24px;
  margin-top: 20px;
`

export const IconLine = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`

export const Divider = styled.div`
  height: 1px;
  margin: 40px 0;
  background: #d1d1d1;
`

/* stacked full-width on mobile, side-by-side from tablet up */
export const ActionButtons = styled.div`
  margin-top: 16px;

  ${media.md`
    display: flex;
    gap: 12px;
  `}
`

export const ActionButton = styled(PulsingGrey)`
  height: 52px;
  margin-top: 12px;
  border-radius: 6px;

  ${media.md`
    flex: 1;
    margin-top: 0;
  `}
`

export const BookingBox = styled.div`
  margin-top: 20px;
  padding: 20px;
  border: 1px solid #e2e2e2;
  border-radius: 8px;
  background: #faf7f2;
`

export const BottomBar = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 5;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 81px;
  padding: 0 16px;
  background: #fff;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.12);

  ${media.lg`
    display: none;
  `}
`

export const BottomBarPrice = styled.div`
  display: flex;
  flex-direction: column;
  gap: 7px;
`
